const defaultWorkingCalendarForm = {
    name: '',
    description: '',
    date: null,
}

export default defaultWorkingCalendarForm